module.exports = __webpack_public_path__ + "static/media/about-box2.b992de1d.jpg";